/* import __COLOCATED_TEMPLATE__ from './trial-extension-dialog.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {
    isOpen: boolean;
    onClose: () => void;
  };
}

const TrialExtensionDialog = templateOnlyComponent<Signature>();
export default TrialExtensionDialog;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'React::TrialExtensionDialog': typeof TrialExtensionDialog;
    'react/trial-extension-dialog': typeof TrialExtensionDialog;
  }
}
